import * as Input from 'components/form/inputs';

interface YearPickerProps {
	name?: string;
	defaultValue?: number;
	required?: boolean;
	onChange?: (year: number) => void;
}

export function YearSelect({
	name,
	defaultValue,
	required,
	onChange,
}: YearPickerProps) {
	const currentDate = new Date();

	const currentYear = currentDate.getFullYear();

	const yearOptions = [];

	for (let y = currentYear; y >= currentYear - 100; y--) {
		yearOptions.push({
			value: y.toString(),
			label: y.toString(),
		});
	}
	const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedYear = parseInt(event.target.value, 10);
		onChange?.(selectedYear);
	};

	return (
		<Input.Select
			name={name}
			defaultValue={defaultValue ?? currentYear}
			required={required}
			onChange={handleOnChange}>
			{yearOptions.map((item) => (
				<option key={item.value} value={item.value}>
					{item.label}
				</option>
			))}
		</Input.Select>
	);
}
